import { atom } from "@byko/lib-recoil";

import type { CustomerAccountMembership } from "@byko/lib-api-rest";

export const filteredAccountsState = atom({
  key: "filteredAccountsState",
  default: [] as CustomerAccountMembership[],
});
